<app-card variant="shadow-bordered" bodyPadding="md" additionalClasses="h-full flex flex-col">
  <div class="flex-1 flex flex-col">
    <div class="flex items-start justify-between">
      <div class="flex-1 min-w-0">
        <h3 class="text-sm font-medium text-base-content/70 mb-2">{{ title() }}</h3>
        <p class="text-3xl font-bold text-base-content mb-2">{{ value() }}</p>
        @if (changeIndicator() || secondaryText()) {
          <div class="flex items-center gap-2 mt-auto">
            @if (changeIndicator()) {
              <span [class]="changeIndicatorClasses()">{{ changeIndicator() }}</span>
            }
            @if (secondaryText()) {
              <span class="text-xs text-base-content/50">{{ secondaryText() }}</span>
            }
          </div>
        }
      </div>
      @if (showIcon()) {
        <div [class]="iconBgClasses()" class="ml-4 flex-shrink-0">
          <ng-content></ng-content>
        </div>
      }
    </div>
  </div>
</app-card>
